import {
  MessageCircle,
  Zap,
  Target,
  TrendingUp,
  Heart,
  Sparkles,
  Activity,
} from "lucide-react";

const EmptyState = () => {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center max-w-2xl">
        {/* Floating Icons Background */}
        <div className="relative mb-12">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-40 h-40 bg-gradient-to-br from-blue-100/50 to-purple-100/50 rounded-full opacity-30 animate-pulse"></div>
          </div>

          {/* Floating Icons */}
          <div className="absolute top-2 left-6 animate-bounce delay-100">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-400 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl rotate-12">
              <Zap className="w-5 h-5 text-white" />
            </div>
          </div>
          <div className="absolute top-6 right-8 animate-bounce delay-300">
            <div className="w-8 h-8 bg-gradient-to-r from-purple-400 to-purple-500 rounded-2xl flex items-center justify-center shadow-xl -rotate-12">
              <Target className="w-4 h-4 text-white" />
            </div>
          </div>
          <div className="absolute bottom-4 left-8 animate-bounce delay-500">
            <div className="w-9 h-9 bg-gradient-to-r from-pink-400 to-pink-500 rounded-2xl flex items-center justify-center shadow-xl rotate-6">
              <TrendingUp className="w-4 h-4 text-white" />
            </div>
          </div>
          <div className="absolute bottom-2 right-6 animate-bounce delay-700">
            <div className="w-7 h-7 bg-gradient-to-r from-green-400 to-green-500 rounded-2xl flex items-center justify-center shadow-xl -rotate-6">
              <Heart className="w-3.5 h-3.5 text-white" />
            </div>
          </div>
          <div className="absolute top-12 left-16 animate-bounce delay-900">
            <div className="w-6 h-6 bg-gradient-to-r from-indigo-400 to-indigo-500 rounded-2xl flex items-center justify-center shadow-xl rotate-45">
              <Sparkles className="w-3 h-3 text-white" />
            </div>
          </div>
          <div className="absolute bottom-8 right-16 animate-bounce delay-1100">
            <div className="w-8 h-8 bg-gradient-to-r from-orange-400 to-orange-500 rounded-2xl flex items-center justify-center shadow-xl -rotate-12">
              <Activity className="w-4 h-4 text-white" />
            </div>
          </div>

          {/* Main Icon */}
          <div className="relative z-10 w-28 h-28 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 rounded-3xl flex items-center justify-center mx-auto shadow-2xl">
            <MessageCircle className="w-14 h-14 text-white" />
            <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-400 rounded-full border-4 border-white animate-pulse"></div>
          </div>
        </div>

        <h3 className="text-4xl font-bold bg-gradient-to-r from-gray-800 via-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
          Welcome to Metabuddy AI
        </h3>
        <p className="text-lg text-gray-600 leading-relaxed mb-8 max-w-lg mx-auto">
        Proactive cybersecurity intelligence — detect anomalies, identify exploits, and stay fortified.
        </p>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {/* Smart Nutrition Card 
          <div className="group relative ">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-400/20 via-blue-500/20 to-blue-600/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative p-8 bg-white/70 backdrop-blur-lg rounded-3xl border border-white/50 shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-600 rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                <Zap className="w-8 h-8 text-white" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2 group-hover:text-blue-600 transition-colors duration-300">
                Smart Nutrition
              </h4>
              <div className="w-12 h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mx-auto opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
            </div>
          </div>*/}

          {/* Workout Plans Card 
          <div className="group relative ">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-400/20 via-purple-500/20 to-purple-600/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative p-8 bg-white/70 backdrop-blur-lg rounded-3xl border border-white/50 shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 via-purple-600 to-pink-600 rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2 group-hover:text-purple-600 transition-colors duration-300">
                Workout Plans
              </h4>
              <div className="w-12 h-1 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mx-auto opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
            </div>
          </div>*/}

          {/* Progress Tracking Card 
          <div className="group relative ">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-400/20 via-pink-500/20 to-rose-600/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative p-8 bg-white/70 backdrop-blur-lg rounded-3xl border border-white/50 shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-pink-500 via-rose-500 to-red-500 rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                <TrendingUp className="w-8 h-8 text-white" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2 group-hover:text-pink-600 transition-colors duration-300">
                Progress Tracking
              </h4>
              <div className="w-12 h-1 bg-gradient-to-r from-pink-500 to-rose-500 rounded-full mx-auto opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
            </div>
          </div>*/}

        </div>
      </div>
    </div>
  );
};

export default EmptyState;
